module.exports = __webpack_public_path__ + "img/b9_01.77db6caa.jpg";